import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import userGroupService from "../services/user-group.service";
import { setMessage } from "./message";
export const fetchUserGroupList = createAsyncThunk(
    'userGroup/fetchUserGroupList',
    async ({ page, pagesize, search , ordering}, thunkAPI) => {
        try {
            const response = await userGroupService.getUserGroupList(page, pagesize, search, ordering);
            return response.data; // Return the full response
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
export const fetchArchivedGroupsList = createAsyncThunk(
    'userGroup/fetchArchivedUsersList',
    async ({page, pagesize, search,ordering}, thunkAPI) => {
        try {
            const response = await userGroupService.getArchiveGroupsList(page, pagesize, search,ordering);
            return response.data; // Assuming response contains { data, count, totalPages, etc. }
        } catch (error) {
            const message =
                (error.response &&
                error.response.data &&
                error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    },
);
export const fetchUserGroupById = createAsyncThunk(
    'userGroup/fetchUserGroupById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await userGroupService.getGroupById(id);
            return response.data; // Return the profile data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);
export const createUserGroup = createAsyncThunk(
    'userGroup/createUserGroup',
    async (payload, thunkAPI) => {
        try {
            const response = await userGroupService.createGroup(payload);
            return response.data; // Assuming response contains the created die size data
        } catch (error) {
            const message = error.response.data ||  error.response.data.name || { message: error.message || "An unexpected error occurred." }; // Fallback
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const updateUserGroup = createAsyncThunk(
    'userGroup/updateUserGroup',
    async ({ id, values }, thunkAPI) => {
        try {
            const response = await userGroupService.updateGroup(id, values);
            return response.data; // Ensure this returns the updated category data
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const archiveUserGroup = createAsyncThunk(
    'userGroup/archiveUserGroup',
    async (id, thunkAPI) => {
        try {
            await userGroupService.archiveGroup(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const unArchiveUserGroup = createAsyncThunk(
    'userGroup/unArchiveUserGroup',
    async (id, thunkAPI) => {
        try {
            await userGroupService.unArchiveGroup(id); // Ensure `id` is used here
            return id; // Return the ID of the deleted group
        } catch (error) {
            const message =
                (error.response &&
                error.response.data &&
                error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue(message);
        }
    },
);




const initialState = {
    data: [],  // Ensure the data is always an empty array initially
    list: [],
    loading: false,
    totalRecord: 0,
    totalPages: 0,
    currentPage: 1,
    status: 'idle',
    error: null,
    hasMore: true,
};

const userGroupSlice = createSlice({
    name: 'userGroup',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        resetUserGroupList: (state) => {
            state.list = []; // This will clear the list
        },
        resetCurrentUserGroupPage: (state) => {
            state.currentPage = 1;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserGroupList.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchUserGroupList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentPage;
                state.data = action.payload.results.data || []; // Correctly access the data array
                state.totalRecord = action.payload.count || 0; // Set total records
                state.totalPages = Math.ceil((action.payload.count || 0) / action.meta.arg.limit); // Calculate total pages
                state.currentPage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchUserGroupList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(fetchArchivedGroupsList.pending, state => {
                state.status = 'loading';
            })
            .addCase(fetchArchivedGroupsList.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const fetchedPage = action.payload.page || state.currentpage;
                state.data = action.payload.results.data || []; // Adjust this to match your API response
                state.totalRecord = action.payload.count || 0;
                state.totalpage = action.payload.totalPages || 0;
                state.currentpage = action.payload.next ? fetchedPage + 1 : fetchedPage;
                state.list = [...state.list, ...action.payload.results.data];
                state.hasMore = !!action.payload.next;
            })
            .addCase(fetchArchivedGroupsList.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });

        builder
            .addCase(fetchUserGroupById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserGroupById.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(fetchUserGroupById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });

        builder
            .addCase(createUserGroup.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createUserGroup.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data.push(action.payload);
            })
            .addCase(createUserGroup.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });

        builder.addCase(updateUserGroup.fulfilled, (state, action) => {
            state.status = 'succeeded';
        });
        builder
            .addCase(archiveUserGroup.pending, state => {
                state.status = 'loading';
            })
            .addCase(archiveUserGroup.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
                state.list = state.list.filter(group => group.id !== action.payload); // Remove the deleted group from list
            })
            .addCase(archiveUserGroup.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.payload;
            });
        builder
            .addCase(unArchiveUserGroup.pending, state => {
                state.status = 'loading';
            })
            .addCase(unArchiveUserGroup.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = state.data.filter(group => group.id !== action.payload); // Remove the deleted group from state
            })
            .addCase(unArchiveUserGroup.rejected, (state, action) => {
                state.status = 'failed';
                state.loading = false;
                state.error = action.error.message;
            });
    }
});

export const { resetUserGroupList, resetCurrentUserGroupPage } = userGroupSlice.actions;
const { reducer } = userGroupSlice;
export default reducer;
